/**
 * What a role sees, and the question asked before changing someone's role.
 * Mirrors the backend rule (core/security.scope_for_role): a partner sees
 * only the leads and enrollments assigned to them; every other role sees all.
 */

export const ROLE_NAME = {
  owner: "Owner",
  admin_fped: "Admin FPED",
  partner_operator: "Partener (operator)",
  viewer: "Viewer",
  admin: "Admin FPED",
};

const RANK = { owner: 3, admin_fped: 2, admin: 2, viewer: 1, partner_operator: 1 };

export function accessOf(role) {
  return role === "partner_operator"
    ? { key: "assigned_only", label: "doar atribuite", title: "Vede doar leadurile și înscrierile atribuite lui" }
    : { key: "all", label: "vede tot", title: "Vede toate leadurile și înscrierile" };
}

/** Same rule as the backend: fewer rights, or a move into a restricted role. */
export function isDemotion(oldRole, newRole) {
  if (oldRole === newRole) return false;
  return (RANK[newRole] ?? 0) < (RANK[oldRole] ?? 0) || newRole === "partner_operator" || newRole === "viewer";
}

export function roleChangeQuestion(user, newRole) {
  const who = user?.name || user?.email || "Utilizatorul";
  const sees = newRole === "partner_operator"
    ? "va vedea doar leadurile și înscrierile atribuite lui"
    : newRole === "viewer"
      ? "va vedea toate leadurile și înscrierile, fără să poată modifica"
      : "va vedea toate leadurile și înscrierile";
  const out = isDemotion(user?.role, newRole) ? " Sesiunile lui deschise se închid și va trebui să se autentifice din nou." : "";
  const org = user?.role === "partner_operator" && newRole !== "partner_operator" && user?.assigned_org
    ? ` Organizația „${user.assigned_org}” se șterge de pe cont.` : "";
  return `${who} devine ${ROLE_NAME[newRole] || newRole} și ${sees}.${out}${org} Continui?`;
}

/**
 * The team — owner and Admin FPED (`admin` is its legacy name). Mirrors the
 * backend's `require_role("owner", "admin")`: what only the team may run
 * (bulk changes on leads, a session reminder sent by hand) is hidden from
 * partners and viewers instead of refused after the click (19.10.2026).
 */
export function isTeam(role) {
  return role === "owner" || role === "admin_fped" || role === "admin";
}
